(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kopstorm-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabsNav = document.querySelector('.tabs-nav');
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');
  const swipeIndicator = document.querySelector('.swipe-indicator');
  
  if (window.innerWidth <= 768) {
    setTimeout(() => {
      tabsNav.classList.add('animate-swipe');
      setTimeout(() => {
        tabsNav.classList.remove('animate-swipe');
      }, 1500);
    }, 1000);
  }

  function updateScrollIndicators() {
    if (tabsNav.scrollWidth > tabsNav.clientWidth) {
      const isAtStart = tabsNav.scrollLeft <= 0;
      const isAtEnd = tabsNav.scrollLeft + tabsNav.clientWidth >= tabsNav.scrollWidth;
      
      tabsNav.classList.toggle('show-left-indicator', !isAtStart);
      tabsNav.classList.toggle('show-right-indicator', !isAtEnd);
      
      if (window.innerWidth <= 768) {
        swipeIndicator.style.display = 'flex';
      } else {
        swipeIndicator.style.display = 'none';
      }
    } else {
      swipeIndicator.style.display = 'none';
    }
  }

  updateScrollIndicators();
  tabsNav.addEventListener('scroll', updateScrollIndicators);
  window.addEventListener('resize', updateScrollIndicators);

  tabButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const tab = this.getAttribute('data-tab');
      
      tabButtons.forEach(function(btn) {
        btn.classList.remove('active');
      });
      
      tabContents.forEach(function(content) {
        content.classList.remove('active');
      });
      
      this.classList.add('active');
      document.getElementById(tab).classList.add('active');
      
      // Ensure clicked tab is visible
      const tabRect = this.getBoundingClientRect();
      const navRect = tabsNav.getBoundingClientRect();
      
      if (tabRect.right > navRect.right) {
        tabsNav.scrollBy({
          left: tabRect.right - navRect.right + 16,
          behavior: 'smooth'
        });
      } else if (tabRect.left < navRect.left) {
        tabsNav.scrollBy({
          left: tabRect.left - navRect.left - 16,
          behavior: 'smooth'
        });
      }
    });
  });

  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      const faqItem = this.parentElement;
      
      const openItems = document.querySelectorAll('.faq-item.open');
      openItems.forEach(function(item) {
        if (item !== faqItem) {
          item.classList.remove('open');
        }
      });
      
      faqItem.classList.toggle('open');
    });
  });

  // Add touch scroll momentum for better mobile experience
  let isScrolling = false;
  let startX;
  let scrollLeft;

  tabsNav.addEventListener('touchstart', (e) => {
    isScrolling = true;
    startX = e.touches[0].pageX - tabsNav.offsetLeft;
    scrollLeft = tabsNav.scrollLeft;
  });

  tabsNav.addEventListener('touchmove', (e) => {
    if (!isScrolling) return;
    e.preventDefault();
    const x = e.touches[0].pageX - tabsNav.offsetLeft;
    const walk = (x - startX) * 2;
    tabsNav.scrollLeft = scrollLeft - walk;
  });

  tabsNav.addEventListener('touchend', () => {
    isScrolling = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var filterChips = document.querySelectorAll('.filter-chip');
  var brandCards = document.querySelectorAll('.brand-card');

  filterChips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      var filterValue = this.getAttribute('data-filter');
      
      // Remove active class from all chips and then add to the clicked chip
      filterChips.forEach(function(chip) {
        chip.classList.remove('active');
      });
      this.classList.add('active');
      
      // If "all" is selected, show every card; otherwise, filter accordingly
      brandCards.forEach(function(card) {
        if (filterValue === 'all' || card.getAttribute('data-filter') === filterValue) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
